
import { Options, Vue } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { RouteLocationNormalizedLoaded } from "vue-router";

@Options({
  components: {},
})
export default class NavMenu extends Vue {
  activeIndex = "home";
  mounted() {
    $(window).on("resize", () => {
      let width: number = $(window).innerWidth() || 0;
      $(".menu-vertical-mask").hide();
      $("body").removeClass("mask");
      if (width <= 992) {
        $(".el-menu--horizontal").hide();
        $(".nav-toggle-btn").show();
        $(".header-right").hide();
      } else {
        $(".el-menu--horizontal").show();
        $(".nav-toggle-btn").hide();
        $(".header-right").show();
      }
    });
    $(window).resize();
    $(".nav-toggle-btn").on("click", () => {
      $(".menu-vertical-mask").show();
      $("body").addClass("mask");
    });
    $(".nav").on("click", e => {
      const display = $(".el-menu--horizontal").css("display");
      const isNav = $(e.target).hasClass("menu-vertical-mask");
      if (display === "none" && isNav) {
        $(".menu-vertical-mask").hide();
        $("body").removeClass("mask");
      }
    });
    const menuItem = (this.$route.name as string).replace("Detail", "") || "";
    this.activeIndex =
      menuItem == "projects" || menuItem == "consult" ? "hiddenMenu" : menuItem;
  }
  @Watch("$route")
  routeChange(to: RouteLocationNormalizedLoaded) {
    // this.keyword = (this.$route.params.keyword as string) || "";
    const menuItem = (this.$route.name as string).replace("Detail", "") || "";
    this.activeIndex = menuItem;
    // this.activeIndex =
    //   menuItem == "projects" || menuItem == "consult" ? "hiddenMenu" : menuItem;
  }
}
